import React from "react";

export default (): JSX.Element => <div className="spinner"></div>;
